import type { ScheduleItem } from "../types";
import { Icon } from "./Icon";

const LABELS: Record<string, string> = {
  confirmed: "Confirmed",
  proposed: "Proposed",
  tbd: "TBD",
  open: "Open",
};

export function StatusBadge({ status }: { status?: ScheduleItem["status"] }) {
  if (!status) return null;
  return (
    <span className={`badge badge-${status}`}>{LABELS[status] ?? status}</span>
  );
}

export function CategoryIcon({ category }: { category: string }) {
  const map: Record<string, string> = {
    flight: "plane",
    lodging: "bed",
    transport: "arrow",
    coffee: "coffee",
    food: "food",
    attraction: "mountain",
    trek: "mountain",
    note: "list",
    open: "clock",
  };
  const isCoffee = category === "coffee";
  return (
    <span
      className={`cat-icon${isCoffee ? " cat-icon-coffee" : ""}`}
      aria-hidden
    >
      <Icon name={map[category] ?? "pin"} size={18} />
    </span>
  );
}
